export const urls = {
  services: '/service',
  colors: '/color',
  login: '/login/worker/',
  check: '/check/worker/',
  posts: '/bill/po',
  getUser: '/user',
  profileBank: '/worker/user/bank',
  workerOffs: '/worker/user/workerOffs',
  workerRating: '/worker/user/rating',
  updateSimpleUser: '/user/login',
  adminService: '/admin/service/',
  adminUser: '/admin/user',
  address: '/address/',
  order: '/worker/order',
  orderDone: '/worker/order/status/done/',
  orderStart: '/worker/order/status/start/',
  emergency: '/worker/user/emergency/',
  orderSingle: '/order/single',
  orderMedia: '/order/media/',
  feedbackFactors: '/feedback/factors',
  cart: '/order/cart',
  pay: '/order/pay',
  paymentVerify: '/order/pay/verify/',
  adminOrder: '/admin/order',
  adminFeedback: '/admin/feedback/',
  adminOrderUpdate: '/admin/order/update',
  ariaWorker: '/order/workers',
  workersOffs: '/user/workerOffs',
  adminLogin: '/admin/login',
  adminDashboard: '/admin/login',
  feedback: '/feedback',
  workerDashboard: '/worker/dashboard/salary',
  workerIncome: '/worker/dashboard/income',
  billChart: '/worker/dashboard/chart',
  transaction: '/worker/transaction',
  sales: '/admin/dashboard/sales'
};
